import { isEmpty } from '@ember/utils';
import moment from 'moment';

export function toCamelCase(str) {
  if (isEmpty(str)) {
    return '';
  }
  return str
    .replace(/[_-]/g, ' ') // Convert underscores and dashes to spaces (word boundaries)
    .trim() // Remove any leading/trailing space caused by replacing dashes/underscores to spaces
    .replace(/[^a-z0-9 ]/gi, '') // Remove remaining non-alphanumeric characters
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (/\s+/.test(match)) {
        return '';
      }
      // lowercase if first letter, otherwise uppercase.
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
}

export function isTruthy(val) {
  switch (val.toLowerCase().trim()) {
    case 'y':
    case 'yes':
    case 'true':
    case '1':
      return true;
    default:
      return false;
  }
}

export function conformDate(str) {
  if (isEmpty(str)) {
    return '';
  }
  let parsed = moment(str, ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY']);
  if (parsed.isValid()) {
    return parsed.format('YYYY-MM-DD');
  } else {
    return '';
  }
}
